import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import TagsGrid from '../components/Grid';
import { TagProvider } from '../store';

import TagFormLayout from './Form';

export default function TagsGridLayout() {
  return <TagProvider>
    <TagsGrid />
    <Router>
      <PrivateRoute path={["/cms/:content_type/tags/add", "/cms/:content_type/tags/:id"]} component={TagFormLayout} />
    </Router>
  </TagProvider>
}
